module.exports = __webpack_public_path__ + "img/BG_green.1d1d669f.gif";